import React, { useEffect, useState } from 'react'

import { folders } from "../../constants"

import "./style.scss";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Http } from '../../../../../helpers/axois';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../stateManager/store';
import NoData from '../../../NoData';
import { ReactComponent as WarningIcon } from '../../../../../assets/svg/warningIcon.svg'
const PAGE_TITLE = "Static Assets"
const PAGE_SUBTITLE = "View, edit or create a asset";

type IFileCount = {
    css: number;
    image: number;
    font: number;
    json: number;
}


export const StaticAssetList = () => {
    const { pathname } = useLocation()
    const history = useHistory();
    const params: { appId: string } = useParams();
    const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
    const currentBranch: { branchId: string } = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId);
    const appversion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[params.appId]);
    const [fileCount, setFileCount] = useState<IFileCount>({ css: 0, font: 0, image: 0, json: 0 })
    const [loading, setLoading] = useState({})
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    var canViewStaticAssets = (orgPermissions.includes('staticAsset.View') && orgPermissions.includes('app.View'))||   loggedInUserId==selectedOrg?.owner;

    const handleFolderRedirect = (folderPath: string) => {
        const appType = pathname.split("/")[4]
        history.push("/apps/list/" + params.appId + "/" + appType + "/static-asset/" + folderPath)
    }

    const fetchAssetsCount = async () => {
        try {
            if(!canViewStaticAssets){
            return
            }
            const payload = {
                "appId": params.appId,
                orgId
            }
            const res: any = await Http.post("/static-asset", payload).toPromise()
            if (res.ok) {
                setFileCount(res.result)
            }
            setLoading(false)
        } catch (error) {
            if (error === "Forbidden") {
                canViewStaticAssets = false
            }
            console.error(error)
            setLoading(false)
        }
    }

    const getFileCount = (label: string): string => {
        switch (label) {
            case "Images":
                return `${fileCount.image} files`
            case "CSS":
                return `${fileCount.css} files`
            case "Fonts":
                return `${fileCount.font} files`
            case "JSON":
                return `${fileCount.json} files`
            default:
                return ""
        }
    }

    useEffect(() => {
        setLoading(false);
        fetchAssetsCount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loading) {
        return (
            <div>Loading...</div>
        )
    }

    return (
        <div className="static-asset__container">
            {canViewStaticAssets ? <>  <div className="static-asset__header">
                <div className="static-asset__header--title">{PAGE_TITLE}</div>
                <div className="static-asset__header--subtitle">{PAGE_SUBTITLE}</div>
            </div>
            <hr />
            <div className="static-asset__body">
                <div className="static-asset__body--container">
                    {folders.map(({ id, label, Icon, path }) => {
                        return (
                            (
                                <div className="static-asset__body--container__folder" key={id} onClick={() => handleFolderRedirect(path)}>
                                    <div className="static-asset__item-container">
                                        <div className={`static-asset__item-container__icon icon--${label.toLowerCase()}`}>
                                            <Icon />
                                        </div>
                                        <div className="static-asset__item-container__description">
                                            <div className="static-asset__item-container--label">{label}</div>
                                            <div className="static-asset__item-container--filecount">{getFileCount(label)}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        )
                    })}
                </div>
                </div></> : <NoData
                svg={WarningIcon}
                header='Not Authorized'
                content='Please request owner of this organization to provide access'
                noButton={true}
            />
            }
        </div>
    )
}
